<mn-svg data-ui-sound mnClickArea class="cu-p c-se" name="copy" (click)="copy($event)" />
@if (to()) {
  <div class="tooltip">
    <div class="text t-s-s">{{ "copied" | mnTranslate }}</div>
  </div>
}
